/* fmtMoney -- MONEY FORMATTING WHERE **ZERO IS AN ANSWER**.
 *
 * Every page in this app declares its own `fmt`, and every one of them renders ZERO as an
 * EM-DASH. That is right, and deliberate: in a salary column, a bonus column or a statement
 * row a dash means "nothing here", and a grid full of $0.00 would be unreadable. Measured:
 * 13 declarations and 109 call sites across client/src. Changing any of them to print
 * "$0.00" would move every zero cell on that page.
 *
 * BUT A SEVERANCE OF ZERO IS NOT NOTHING -- IT IS AN ANSWER. The operator chose a mode and
 * typed 0, and the whole three-state design (unanswered / a value / a deliberate 0) rests on
 * that being VISIBLE. Rendering it as a dash makes an answer look like an absence, which is
 * the exact ambiguity 09-15's take-rate defect and 09-17's growth-period wipe both turned on.
 *
 * So this is the formatter for figures where the operator SAID something, including zero.
 * ONE owner, imported by every such site -- not a copy per page.
 *
 * NOTE: null / undefined / a non-number render as an em-dash, because those genuinely ARE
 * "no answer". Only a finite number -- 0 included -- is formatted.
 *
 * !! THE NAME IS ALREADY TAKEN TWICE, BLOCK-SCOPED, IN AdminPage.js (:9502 and :10625):
 *      const fmtMoney = (n) => Number(n || 0).toLocaleString(...)
 * Those are function-local consts and AdminPage imports nothing here, so there is NO
 * collision today -- but an import added to that file later would be SILENTLY SHADOWED by
 * them, which is a quiet way to get the wrong formatter. They are also the first two
 * candidates to fold into this owner: they do the same job (a zero prints as 0.00) and
 * differ only in prepending the "$" in JSX and in `n || 0`, which turns a null into a
 * zero -- the rule-44 shape. ==> FOLDING THEM IN IS ITS OWN PASS: it is a RENDERED change
 * on the wizard and needs its own A/B, so it was deliberately not done here.
 */
const r2 = n => Math.round(n * 100) / 100;

export function fmtMoney(n) {
    if (n === null || n === undefined) return "\u2014";
    const v = Number(n);
    if (!Number.isFinite(v)) return "\u2014";
    const s = new Intl.NumberFormat("en-US", {
        style: "currency", currency: "USD",
        minimumFractionDigits: 2, maximumFractionDigits: 2,
    }).format(Math.abs(r2(v)));
    return v < 0 ? "(" + s + ")" : s;
}
